/* SupremeFolio's Portfolio file*/

/* Change this file to get your personal Porfolio */

/* Some Tips:
★ Place your images in "src/assets/images" path
★ Place your custom loading animations in assets/lottie
★ Set value to false to hide a section or an entire page
★ Get fontAwesomeClassnames from https://www.fontawesome.com
★ Set blogSection false to hide all kind of blogs
*/

/*
Some informations are kept unchanged according to component owners
Credits: masterPortfolio(https://github.com/ashutosh1919/masterPortfolio)
         developerFolio(https://github.com/saadpasta/developerFolio)
*/

// Website related settings
// Which pages will be enabled

const pageEnabled = {
  splash: true, // Change this to false if you don't want Splash screen

  education: true, // Change this to false if you don't want education (degrees, certifications, competitiveSites) page

  projects: true, // Change this to false if you don't want projects (from github data) and publications page

  opensource: true, // Change this to false if you don't want opensource contribution (from github data) page

  hobbies: true, // Change this to false if you don't want hobbies page

  experience: false, // Change this to false if you don't want experience page

  contact: true, // Change this to false if you don't want contact page
};

// Routing with or without '#'
const routerValue =
  "HashRouter";
/* Supported values:
                    1. HashRouter(for github hosted user Pages)
                    2. BrowserRouter (for regular hosting)
                    */

// Splash Screen

const splashScreen = {
  useLottie: true, // setting it false will show animation of src/components/loader
  animationFile: "starLoading"
    /* Supported Values
                                        1. splashAnimation
                                        2. email
                                        3. build
                                        4. landingPerson
                                        5. codingPerson
                                        6. geometricLoader
                                        7. starLoading
                                        8. ripple
                                        9. nightDay
                                        10. littleRobot
                                        11. poolChartLoading
                                        */
    ,
  duration: 1500, // Set animation duration(milliseconds) as per your animation
};

/**************               Home Page                    ****************/

//SEO Related settings
const seo = {
  title: "Abduhamid's Portfolio",
  description: "Portfolio Website of Abduhamid",
  og: {
    title: "Abduhamid Portfolio",
    type: "website",
    url: "https://Abduhamid.github.io/",
  },
};

//Home Page
const greeting = {
  title: "Abduhamid",
  logo_name: "Abduhamid",
  nickname: "The Complex",
  subTitle: "A passionate individual who always thrives to work on end to end products which develop sustainable and scalable social and technical systems to create impact.",
  resumeLink: "https://drive.google.com/file/d/1n3QgoIf5mmfp5zXETdY3iQVs1wezRiQ2/view",
  portfolio_repository: "https://github.com/abduhamidweb", //star-me-on-github button
  githubProfile: "https://github.com/abduhamidweb", //more projects button
};

const socialMediaLinks = [
  /* Your Social Media Link */
  // github: "https://github.com/abduhamidweb",
  // linkedin: "https://www.linkedin.com/in/ashutosh-hathidara-88710b138/",
  // gmail: "ashutoshhathidara98@gmail.com",
  // gitlab: "https://gitlab.com/ashutoshhathidara98",
  // facebook: "https://www.facebook.com/laymanbrother.19/",
  // twitter: "https://twitter.com/ashutosh_1919",
  // instagram: "https://www.instagram.com/layman_brother/"

  {
    name: "Github",
    link: "https://github.com/abduhamidweb",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/abduhamidweb/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  // {
  //   name: "YouTube",
  //   link: "https://youtube.com/c/DevSense19",
  //   fontAwesomeIcon: "fa-youtube", // Reference https://fontawesome.com/icons/youtube?style=brands
  //   backgroundColor: "#FF0000", // Reference https://simpleicons.org/?q=youtube
  // },
  {
    name: "Gmail",
    link: "mailto:abduhamidbotirovweb@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  // {
  //   name: "Twitter",
  //   link: "https://twitter.com/ashutosh_1919",
  //   fontAwesomeIcon: "fa-twitter", // Reference https://fontawesome.com/icons/twitter?style=brands
  //   backgroundColor: "#1DA1F2", // Reference https://simpleicons.org/?q=twitter
  // },
  // {
  //   name: "Facebook",
  //   link: "https://www.facebook.com/laymanbrother.19/",
  //   fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
  //   backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  // },
  {
    name: "Instagram",
    link: "https://www.instagram.com/coderwizards/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
];


// Skill Information

const skills = {
  display: true, // Set it true to display your skills
  data: [{
      title: "Terminal Based Tools",
      imageName: "AppDevelopImg"
        /* Available imageNames:

             FullStackImg,
             TerminalImg,
             DesignImg,
             AppDevelopImg,
             CloudInfraImg,
             DataScienceImg.
             */
        ,
      skills: [
        "⚡ Developing highly scalable production ready models for various deeplearning and statistical use cases",
        "⚡ Experience of working with Computer Vision and NLP projects",
        "⚡ Complex quantitative modelling for dynamic forecasting and time series analysis",
      ],
      softwareSkills: [{
          skillName: "nodeJs",
          fontAwesomeClassname: "logos-nodejs",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Graphql",
          fontAwesomeClassname: "simple-icons:graphql",
          style: {
            backgroundColor: "white",
            color: "#D00000",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "logos-javascript",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
      ],
    },
    {
      title: "Full Stack Development",
      imageName: "FullStackImg",
      skills: [
        "⚡ Building responsive website front end using React-Redux",
        "⚡ Building a powerful database using Postgres and Mongodb.",
        "⚡ Creating application backend in Node, Express & fastify",
      ],
      softwareSkills: [{
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "Sass",
          fontAwesomeClassname: "simple-icons:sass",
          style: {
            color: "#CC6699",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "typescript",
          fontAwesomeClassname: "simple-icons:typescript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "Redux",
          fontAwesomeClassname: "simple-icons:redux",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "Yarn",
          fontAwesomeClassname: "simple-icons:yarn",
          style: {
            color: "#2C8EBB",
          },
        },
        {
          skillName: "express",
          fontAwesomeClassname: "simple-icons:express",
          style: {
            color: "#663399",
          },
        },
        {
          skillName: "fastify",
          fontAwesomeClassname: "simple-icons:fastify",
          style: {
            color: "#663399",
          },
        },
        {
          skillName: "graphql",
          fontAwesomeClassname: "simple-icons:graphql",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "nestjs",
          fontAwesomeClassname: "simple-icons:nestjs",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "redis",
          fontAwesomeClassname: "simple-icons:redis",
          style: {
            color: "#02569B",
          },
        },
        //        {
        //   skillName: "redis",
        //   fontAwesomeClassname: "simple-icons:redis",
        //   style: {
        //     color: "#02569B",
        //   },
        // },
      ],
    },
    // {
    //   title: "Android App Development",
    //   imageName:
    //     "AppDevelopImg" /* Available imageNames:

    //   FullStackImg,
    //   TerminalImg,
    //   DesignImg,
    //   AppDevelopImg,
    //   CloudInfraImg,
    //   DataScienceImg.
    //   */,
    //   skills: [
    //     "⚡ Stil beginner in this field.",
    //     "⚡ Created a simple calculator!",
    //     "⚡ Deploying a light version of messenger to share files easily.",
    //     "⚡ Wish to create complex apps soon!",
    //   ],
    //   softwareSkills: [
    //     {
    //       skillName: "Java",
    //       fontAwesomeClassname: "simple-icons:java",
    //       style: {
    //         color: "#4285F4",
    //       },
    //     },
    //     {
    //       skillName: "Dart",
    //       fontAwesomeClassname: "simple-icons:dart",
    //       style: {
    //         color: "#FF9900",
    //       },
    //     },
    //     {
    //       skillName: "Kotlin",
    //       fontAwesomeClassname: "simple-icons:kotlin",
    //       style: {
    //         color: "#0089D6",
    //       },
    //     },
    //   ],
    // },
    // {
    //   title: "Reverse Engineering",
    //   imageName: "DesignImg",
    //   skills: [
    //     "⚡ Though I mostly code from scratch, I also like to modify other's codes.",
    //     "⚡ Basically I take a cool project and recreate it enhancing new features!",
    //     "⚡ My recreated codes also have a fresh new UI.",
    //   ],
    //   softwareSkills: [
    //     {
    //       skillName: "Python",
    //       fontAwesomeClassname: "simple-icons:python",
    //       style: {
    //         color: "#FF2BC2",
    //       },
    //     },
    //     {
    //       skillName: "Shell",
    //       fontAwesomeClassname: "simple-icons:shell",
    //       style: {
    //         color: "#F24E1E",
    //       },
    //     },
    //     {
    //       skillName: "Ruby",
    //       fontAwesomeClassname: "logos-ruby",
    //       style: {
    //         color: "#FF7C00",
    //       },
    //     },
    //     {
    //       skillName: "JavaScript",
    //       fontAwesomeClassname: "simple-icons:javascript",
    //       style: {
    //         backgroundColor: "transparent",
    //         color: "#0089D6",
    //       },
    //     },
    //   ],
    // },
    {
      title: "Cloud Infra-Architecture",
      imageName: "CloudInfraImg",
      skills: [
        "⚡ Experience working on multiple cloud platforms",
        "⚡ Hosting and maintaining websites on virtual machine instances along with integration of databases",
        "⚡ Deploying deep learning models on cloud to use on mobile devices",
        "⚡ Setting up streaming jobs from DB to Server or vice-versa on GCP and AWS",
      ],
      softwareSkills: [
        // {
        //   skillName: "GCP",
        //   fontAwesomeClassname: "simple-icons:googlecloud",
        //   style: {
        //     color: "#4285F4",
        //   },
        // },
        // {
        //   skillName: "AWS",
        //   fontAwesomeClassname: "simple-icons:amazonaws",
        //   style: {
        //     color: "#FF9900",
        //   },
        // },
        // {
        //   skillName: "Azure",
        //   fontAwesomeClassname: "simple-icons:microsoftazure",
        //   style: {
        //     color: "#0089D6",
        //   },
        // },
        // {
        //   skillName: "Firebase",
        //   fontAwesomeClassname: "simple-icons:firebase",
        //   style: {
        //     color: "#FFCA28",
        //   },
        // },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "googlesheets",
          fontAwesomeClassname: "simple-icons:googlesheets",
          style: {
            color: "#326CE5",
          },
        },
      ],
    },
  ],
};

const techStack = {
  // Skill Part
  display: true, // Set it to true to view skillbars of language
  title: "Proficiency",
  experience: [{
      Stack: "HTML", // Insert stack or technology or language you have experience in
      progressPercentage: "90%", // Insert relative proficiency in percentage
    },
    {
      Stack: "CSS/SASS",
      progressPercentage: "90%",
    },
    {
      Stack: "JavaScript/TypeScript",
      progressPercentage: "75%",
    },
    {
      Stack: "React/Redux-tolkit",
      progressPercentage: "80%",
    },
    {
      Stack: "NodeJs",
      progressPercentage: "85%",
    }, {
      Stack: "ExpressJs",
      progressPercentage: "85%",
    }, {
      Stack: "Fastfy",
      progressPercentage: "65%",
    }, {
      Stack: "SOCKET",
      progressPercentage: "65%",
    }, {
      Stack: "PostgreSQL",
      progressPercentage: "65%",
    }, {
      Stack: "MongoDB",
      progressPercentage: "85%",
    }, {
      Stack: "GraphQL",
      progressPercentage: "65%",
    }, {
      Stack: "Typescript",
      progressPercentage: "65%",
    }, {
      Stack: "Redis",
      progressPercentage: "75%",
    },
    // {
    //   Stack: "GRAPQL",
    //   progressPercentage: "70%",
    // },
    // {
    //   Stack: "MongoDB",
    //   progressPercentage: "90%",
    // },
    // {
    //   Stack: "Python",
    //   progressPercentage: "80%",
    // },
    // {
    //   Stack: "Shell",
    //   progressPercentage: "80%",
    // },
    // {
    //   Stack: "Perl",
    //   progressPercentage: "70%",
    // },
    // {
    //   Stack: "Ruby",
    //   progressPercentage: "70%",
    // },
    // {
    //   Stack: "C",
    //   progressPercentage: "60%",
    // },
    // {
    //   Stack: "Rust",
    //   progressPercentage: "60%",
    // },
    // {
    //   Stack: "Java",
    //   progressPercentage: "60%",
    // },
    // {
    //   Stack: "Lua",
    //   progressPercentage: "60%",
    // },
    // {
    //   Stack: "GO",
    //   progressPercentage: "60%",
    // },
    // {
    //   Stack: "CPP",
    //   progressPercentage: "50%",
    // },
  ],
};

// Top Contributioned projects
const bigProjects = {
  display: false, // Set it true to show big projects
  title: "Big Projects",
  subtitle: "Some startups and companies that i helped to create their tech",
  projects: [{
      image: "saayaHealthLogo.png",
      projectName: "Saayahealth",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [{
          name: "Visit Website",
          url: "http://saayahealth.com/",
        },
        //  you can add extra buttons here.
      ],
    },
    {
      image: "nextuLogo.jpg",
      projectName: "Nextu",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [{
        name: "Visit Website",
        url: "http://nextu.se/",
      }, ],
    },
  ],
};

const blogSection = {
  display: "none", // Set it none to hide blogs or set it to hardcdoded for following blogs otherwise you can set it to medium to show your fetched(if you used your username for fetcher.mjs) medium blogs
  title: "Blogs",
  subtitle: "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  blogs: [{
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description: "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?",
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description: "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies.",
    },
  ],
};

const talkSection = {
  display: false, // Set it true to show talks
  title: "Talks",
  subtitle: "I love to share my limited knowledge and get a speaker badge",

  talks: [{
    title: "Build Actions For Google Assistant",
    subtitle: "Codelab at GDG DevFest Karachi 2019",
    slides_url: "https://bit.ly/saadpasta-slides",
    event_url: "https://www.facebook.com/events/2339906106275053/",
  }, ],
};

// Podcast Section

const podcastSection = {
  display: false, // Set it true to show your podcasts
  title: "Podcast",
  subtitle: "I love to talk about myself and technology",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo",
  ],
};

// Your tweets displayed in a iframe
const twitterUsername = "none"; // set it none to display no tweets

/****************               Education Page          ****************/

// Your profiles in Competitive Sites to be displayed in education page
const competitiveSites = {
  display: false, // Set it to true to show icons containing links to your profile in respective sites
  competitiveSites: [{
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/layman_brother",
    },
    {
      siteName: "Codechef",
      iconifyClassname: "simple-icons:codechef",
      style: {
        color: "#5B4638",
      },
      profileLink: "https://www.codechef.com/users/ashutosh_1919",
    },
    {
      siteName: "Codeforces",
      iconifyClassname: "simple-icons:codeforces",
      style: {
        color: "#1F8ACB",
      },
      profileLink: "http://codeforces.com/profile/layman_brother",
    },
    {
      siteName: "Hackerearth",
      iconifyClassname: "simple-icons:hackerearth",
      style: {
        color: "#323754",
      },
      profileLink: "https://www.hackerearth.com/@ashutosh391",
    },
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      profileLink: "https://www.kaggle.com/laymanbrother",
    },
  ],
};

// Degrees received from institutions
const degrees = {
  display: true, // Set it false to hide degrees, defaults to true
  degrees: [

    {
      title: "Syrdaryo region Khavos district 1 IDUM.",
      subtitle: "Specialized general school of informatics and mathematics.",
      logo_path: "maktabim.png",
      alt_name: "IIITDM Kurnool",
      duration: "2016 - 2020",
      descriptions: [
        "⚡ This is my first school in the computer field.",
        "⚡ Additionally, I have taught courses in deep learning, data science, programming theory, and full stack development.",
        "⚡ I was selected for a scholarship given to the top 4% of students in my school. I have been recognized by the proud director for achieving the best performance in computer science courses.",
      ],
      website_link: "https://maktab.uz/",
    },
    {
      title: "It Park Center",
      subtitle: " It was the IT-Park Center educational center that helped me choose my first programming field in the computer industry.",
      logo_path: "it_park.png",
      alt_name: "Najot Ta'lim",
      duration: "2020 - 2022",
      descriptions: [
        "⚡ I have learned the basics of programming in this place.",
        "⚡ I have learned frontend technologies such as HTML, CSS, SCSS, JavaScript, Gulp, and jQuery in this place.",
        "⚡ I have learned backend programming languages such as PHP, Laravel, WordPress, Open Server, etc. in this place.",
      ],
      website_link: "https://it-park.uz/uz/itpark/news/sirdaryo-viloyatida-it-park-filiali-it-maktablar-va-it-markazlarning-ochilishi",
    }, {
      title: "Albison",
      subtitle: "This is Albison It Companya, which has given me a lot of experience in the field from the frontend.",
      logo_path: "albison1.png",
      alt_name: "Najot Ta'lim",
      duration: "2022 - 2023",
      descriptions: [
        "⚡ I have deeply learned and gained experience in frontend technologies such as HTML, CSS, and JavaScript programming language in this place.",
        "⚡ I left this place because my knowledge gained here was not sufficient to start working.",
      ],
      website_link: "https://www.albison.uz/",
    }, {
      title: "Najot Ta'lim",
      subtitle: "Najot Ta'lim is the educational center that has brought me significant changes.",
      logo_path: "najot.png",
      alt_name: "Najot Ta'lim",
      duration: "2022 - 2023",
      descriptions: [
        "⚡ I have learned Full-Stack web development here.",
        "⚡ I have learned frontend technologies such as HTML, CSS, SCSS, Tailwind, JavaScript, TypeScript, React, Redux, and Redux/toolkit in this place.",
        "⚡ I have learned programming languages such as Node.js, OOP, Express.js, Socket, JWT, Postgres, MongoDB, GraphQL, ORM, TypeScript, Redis, etc. in this place.",
      ],
      website_link: "https://najottalim.uz/",
    }, {
      title: "Everest",
      subtitle: "During my learning journey of programming in this place, I also learned English",
      logo_path: "everest.png",
      alt_name: "Everest",
      duration: "2022 - 2023",
      descriptions: [
        "⚡ I have been learning English for 6 months in a row, and I plan to continue learning it in the future.",
      ],
      website_link: "https://www.instagram.com/everest_learning_center/",
    },
  ],
};

// Certifications in education page
const certifications = {
  display: true, // Set it false to hide certifications, defaults to true
  certifications: [{
      title: "Fundamentals of Networking Engineering",
      subtitle: "- Hussein Nasser",
      logo_path: "udemy_logo3.png",
      certificate_link: "https://udemy-certificate.s3.amazonaws.com/image/UC-c1d3a80e-7f2c-450d-8af6-bfccd2d5f2b9.jpg",
      alt_name: "Udemy",
      color_code: "#8C151599",
    },
    // {
    //   title: "Deep Learning",
    //   subtitle: "- Andrew Ng",
    //   logo_path: "deeplearning_ai_logo.png",
    //   certificate_link: "https://www.coursera.org/account/accomplishments/specialization/H8CPSFXAJD2G",
    //   alt_name: "deeplearning.ai",
    //   color_code: "#00000099",
    // },
    // {
    //   title: "ML on GCP",
    //   subtitle: "- GCP Training",
    //   logo_path: "google_logo.png",
    //   certificate_link: "https://www.coursera.org/account/accomplishments/specialization/EB4VJARK8647",
    //   alt_name: "Google",
    //   color_code: "#0C9D5899",
    // },
    // {
    //   title: "Data Science",
    //   subtitle: "- Alex Aklson",
    //   logo_path: "ibm_logo.png",
    //   certificate_link: "https://www.coursera.org/account/accomplishments/specialization/PLEAPCSJBZT5",
    //   alt_name: "IBM",
    //   color_code: "#1F70C199",
    // },
    // {
    //   title: "Big Data",
    //   subtitle: "- Kim Akers",
    //   logo_path: "microsoft_logo.png",
    //   certificate_link: "https://drive.google.com/file/d/164zKCFOsI4vGqokc-Qj-e_D00kLDHIrG/view",
    //   alt_name: "Microsoft",
    //   color_code: "#D83B0199",
    // },
    // {
    //   title: "Advanced Data Science",
    //   subtitle: "- Romeo Kienzler",
    //   logo_path: "ibm_logo.png",
    //   certificate_link: "https://www.coursera.org/account/accomplishments/verify/BH2T9BRU87BH",
    //   alt_name: "IBM",
    //   color_code: "#1F70C199",
    // },
    // {
    //   title: "Advanced ML on GCP",
    //   subtitle: "- GCP Training",
    //   logo_path: "google_logo.png",
    //   certificate_link: "https://www.coursera.org/account/accomplishments/verify/5JZZM7TNQ2AV",
    //   alt_name: "Google",
    //   color_code: "#0C9D5899",
    // },
    // {
    //   title: "DL on Tensorflow",
    //   subtitle: "- Laurence Moroney",
    //   logo_path: "deeplearning_ai_logo.png",
    //   certificate_link: "https://www.coursera.org/account/accomplishments/verify/6T4DCUGNK8J8",
    //   alt_name: "deeplearning.ai",
    //   color_code: "#00000099",
    // },
    // {
    //   title: "Fullstack Development",
    //   subtitle: "- Jogesh Muppala",
    //   logo_path: "coursera_logo.png",
    //   certificate_link: "https://www.coursera.org/account/accomplishments/certificate/NRANJA66Y2YA",
    //   alt_name: "Coursera",
    //   color_code: "#2A73CC",
    // },
    // {
    //   title: "Kuberenetes on GCP",
    //   subtitle: "- Qwiklabs",
    //   logo_path: "gcp_logo.png",
    //   certificate_link: "https://google.qwiklabs.com/public_profiles/e4d5a92b-faf6-4679-a70b-a9047c0cd750",
    //   alt_name: "GCP",
    //   color_code: "#4285F499",
    // },
    // {
    //   title: "Cryptography",
    //   subtitle: "- Saurabh Mukhopadhyay",
    //   logo_path: "nptel_logo.png",
    //   certificate_link: "https://drive.google.com/open?id=1z5ExD_QJVdU0slLkp8CBqSF3-C3g-ro_",
    //   alt_name: "NPTEL",
    //   color_code: "#FFBB0099",
    // },
    // {
    //   title: "Cloud Architecture",
    //   subtitle: "- Qwiklabs",
    //   logo_path: "gcp_logo.png",
    //   certificate_link: "https://google.qwiklabs.com/public_profiles/5fab4b2d-be6f-408c-8dcb-6d3b58ecb4a2",
    //   alt_name: "GCP",
    //   color_code: "#4285F499",
    // },
  ],
};

/*******************          Experience Page          ****************/

const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Volunteership",
  description: "I have worked with many evolving startups as ML and DL Developer, Designer and Software Architect. I have also worked with some well established companies mostly as AI Developer. I love organising events and that is why I am also involved with many opensource communities as a representative.",
  header_image_path: "experience.svg",
  sections: [{
      title: "Work",
      experiences: [{
          title: "Associate AI Engineer",
          company: "Legato Health Technology",
          company_url: "https://legatohealthtech.com/",
          logo_path: "legato_logo.png",
          duration: "June 2020 - PRESENT",
          location: "Hyderabad, Telangana",
          description: "I am working on automating healthcare products. The projects involve automation for process improvements and for significantly enhancing the profits. I am currently working on Cancer Survival and Reoccurence Prediction. Our goal is to make AI system which scales and removes doctor dependency as much as possible.",
          color: "#0879bf",
        },
        {
          title: "Android and ML Developer",
          company: "Muffito Incorporation",
          company_url: "https://www.linkedin.com/company/muffito-inc/about/",
          logo_path: "muffito_logo.png",
          duration: "May 2018 - Oct 2018",
          location: "Pune, Maharashtra",
          description: "I have created complete Android Application for locating Pub, Bar and beverage shops around you. I have also worked on implementation of algorithms for Face Detection, Text extraction from Image. I was involved in a team for creating complete software architecure of mobile and web application as well as admin panel for company.",
          color: "#9b1578",
        },
        {
          title: "Android Developer",
          company: "FreeCopy Pvt. Ltd.",
          company_url: "https://www.linkedin.com/company/freecopy/about/",
          logo_path: "freecopy_logo.png",
          duration: "Nov 2017 - Dec 2017",
          location: "Ahmedabad, Gujarat",
          description: "FreeCopy is the Start up from Indian Institute of Management, Ahmedabad. I have changed the integration of the whole app from Google to Firebase. I learnt the efﬁcient ways of Data communications like Retroﬁt, Eventbus etc. I experienced the real time start up. I learnt the Design thinking of UI on perspective of People.",
          color: "#fc1f20",
        },
      ],
    },
    {
      title: "Internships",
      experiences: [{
          title: "Data Science Research Intern",
          company: "Delhivery Pvt. Ltd.",
          company_url: "https://www.delhivery.com/",
          logo_path: "delhivery_logo.png",
          duration: "May 2019 - Sept 2019",
          location: "Gurgaon, Haryana",
          description: "I have worked on project of predicting freight rates based on previous data. There were two objectives: (1) To build a forecasting engine to predict daily freight rates. (2) To embed feature in the model which can explain the seasonal major changes in freight rate based on regions and locations. I have closely worked with deep learning models in combination with statistical methods to create solution for this. At the end of internship, I had created model deployed on AWS EC2 with the use of Kafka stream jobs, ElasticSearch and PostgreSQL.",
          color: "#ee3c26",
        },
        {
          title: "Data Science Intern",
          company: "Intel Indexer LLC",
          company_url: "https://opencorporates.com/companies/us_dc/EXTUID_4170286",
          logo_path: "intel_logo.jpg",
          duration: "Nov 2018 - Dec 2018",
          location: "Work From Home",
          description: "This is financial Solution Company. I have made Supervised Learning model for the company which can perform time series analysis on Stock price data for 32 companies. I have built LSTM Neural Networks Model and trained the data of 32 companies for last 2 years. This model is also used for forecasting.",
          color: "#0071C5",
        },
      ],
    },
    {
      title: "Volunteerships",
      experiences: [{
          title: "Google Explore ML Facilitator",
          company: "Google",
          company_url: "https://about.google/",
          logo_path: "google_logo.png",
          duration: "June 2019 - April 2020",
          location: "Hyderabad, Telangana",
          description: "Explore Machine Learning (ML) is a Google-sponsored program for university students to get started with Machine Learning. The curriculum offers 3 tracks of ML Content (Beginner, Intermediate, Advanced) and relies on university student facilitators to train other students on campus and to build opensource projects under this program.",
          color: "#4285F4",
        },
        {
          title: "Microsoft Student Partner",
          company: "Microsoft",
          company_url: "https://www.microsoft.com/",
          logo_path: "microsoft_logo.png",
          duration: "Aug 2019 - May 2020",
          location: "Hyderabad, Telangana",
          description: "Microsoft Student Partner is a program for university students to lead the awareness and use of Cloud especially Azure tools in the development of their projects and startups. Under this program, I have organised hands on workshops and seminars to teach Cloud Computing concepts to students.",
          color: "#D83B01",
        },
        {
          title: "Mozilla Campus Captain",
          company: "Mozilla",
          company_url: "https://www.mozilla.org/",
          logo_path: "mozilla_logo.png",
          duration: "Oct 2019 - May 2020",
          location: "Kurnool, Andhra Pradesh",
          description: "My responsibility for this program was to create opensource environment in college and in the city. We have organised multiple hackathons on the problems collected by ordinary people from Kurnool city. We have build opensource community of our own college. The community is available at dsc_iiitdmk on github.",
          color: "#000000",
        },
        {
          title: "Developer Students Club Member",
          company: "DSC IIITDM Kurnool",
          company_url: "https://www.linkedin.com/company/developer-students-club-iiitdm-kurnool",
          logo_path: "dsc_logo.png",
          duration: "Jan 2018 - May 2020",
          location: "Kurnool, Andhra Pradesh",
          description: "We have well established developer club in college which is directly associated with Google Developers. We have developed many interdisciplinary projects under the membership of this club. We have organised workshops and activities on Android Application Development, Flutter and React JS.",
          color: "#0C9D58",
        },
        {
          title: "Developer Program Member",
          company: "Github",
          company_url: "https://github.com/",
          logo_path: "github_logo.png",
          duration: "July 2019 - PRESENT",
          location: "Work From Home",
          description: "I am actively contributing to many opensource projects. I have contributed to projects of organisations like Tensorflow, Uber, Facebook, Google, Scikit-learn, Kiwix, Sympy, Python, NVLabs, Fossasia, Netrack, Keras etc. These contributions include bug fixes, feature requests and formulating proper documentation for project.",
          color: "#181717",
        },
      ],
    },
  ],
};

/********************              Hobbies         ********************/

const hobbies = {
  title: "Hobbies",
  subTitle: "I spend my leisure with my hobbies!",
  hobbies: [{
      title: "Reading Books",
      description: "I love to read sci-fi and detective books!",
      image_path: "Reading.png",
    },
    {
      title: "Writing",
      description: "I write poems and stories when I get free times!",
      image_path: "Writing.png",
    },
    {
      title: "Memeing",
      description: "I have a collection of meme templates and I use them to generate memes!",
      image_path: "Memeing.png",
    },
    {
      title: "Listening Music",
      description: "I am a fan of Alan Walker and Linkin Park!",
      image_path: "Music.png",
    },
  ],
};

/****************            OpenSource Page           ********************/

const openSource = {
  organisations: false, // Set it false to hide contributions in github organisations, defaults to true

  issues: true, // Set it false to hide your opened isssues, defaults to true

  pull_requests: true, // Set it false to hide your pull requests in github organisations, defaults to true

  issue_chart: true, // Set it false to hide issue chart, defaults to true

  pr_chart: true, // Set it false to hide pull requests chart, defaults to true
};

/****************            Projects Page           ********************/

// Projects (Github) Section of Projects Page
const projects = {
  display: true, // Set it false to hide your pinned projects in github, defaults to true
  title: "Projects",
  description: "My projects are mostly open source. I like to contribute in other's project. I always try my best to enhance every project to the peak!",
  avatar_image_path: "projects_image.svg",
};

// Publication Section of Projects Page
const publications = {
  display: true, // Set it true to show publications
  title: "Publications",
  description: "I have worked on and published a few research papers and publications of my own.",
  avatar_image_path: "projects_image.svg",
  publications: {
    data: [{
        id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzQ=",
        name: "Restaurant",
        createdAt: "2023-06-01",
        description: `
    The Restaurant project is a full-stack web application that I developed using HTML, CSS, JavaScript, MongoDB, and Express. The application is designed to allow customers to browse restaurant menus, place orders, and make reservations online.
On the front-end side, I used HTML and CSS to create a responsive and visually appealing user interface. I also used JavaScript to add interactivity to the application, such as filtering menus and validating user input.
On the back-end side, I used MongoDB as the database to store restaurant data, including menu items, prices, and customer information. I also used Express to create RESTful APIs that handle user requests and interact with the database.
The application features include a user-friendly menu that displays food items, their prices, and descriptions, along with photos to help users make informed decisions. Users can also place orders and make reservations directly from the website, and receive confirmation messages once their requests are processed.
Overall, the Restaurant project showcases my skills in full-stack web development, including designing and implementing user interfaces, creating RESTful APIs, and managing databases. The application is functional and can be used to manage restaurant operations, making it a valuable addition to any restaurant owner's toolkit. 
in this restaurant you also have the opportunity to open and manage your own restaurant.you need to contact me
for that.
I will give you the login and password.By using this login and password, you will be able to open a new restaurant and fill it with information to manage your restaurant.
    `,
        url: "https://restaurantnt.netlify.app/index.html",
      },
      {
        id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzQ=",
        name: "Cosmos",
        createdAt: "2022.12.04",
        description: `
    The goal of my project: when a user visits a web page
    to give him information about the universe.
     `,
        url: "https://cosmosdev.netlify.app/",
      },
      {
        id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzQ=",
        name: "Agency",
        createdAt: " 2022.12.04",
        description: `
    The goal of my project: introducing students to educational courses.
     `,
        url: "https://quiet-concha-ee2e99.netlify.app/",
      },



      {
        id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzQ=",
        name: "Youtube",
        createdAt: " 2023.03.05",
        description: `
    The goal of my project: To watch video content
     `,
        url: "luxury-malasada-5d68fe.netlify.app/",
      },
      {
        id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzQ=https://github.com/abduhamidweb/SRM-Backend",
        name: "English dictionary",
        createdAt: " 2023.03.11",
        description: `
    The goal of my project: backend
    for dictionaries in English or other languages.you can create more books and fill the books with dictionaries.
     `,
        url: "https://github.com/abduhamidweb/English-words-book-random-question",
      },
      {
        id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzQ=",
        name: "SRM-Backend",
        createdAt: " 2023.03.18",
        description: `
    The goal of my project: the backend part of the website of one training center.
     `,
        url: "https://github.com/abduhamidweb/SRM-Backend",
      },
      {
        id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzQ=https://github.com/abduhamidweb/SRM-Backend",
        name: "Learn English words with context and definitions",
        createdAt: " 2023.03.24",
        description: `
    The goal of my project: looking
    for a word and tapping on it to learn context and definition
     `,
        url: "https://polite-douhua-6bc935.netlify.app/",
      },

      {
        id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzQ=",
        name: "Courses",
        createdAt: " 2023.02.01",
        description: `
    The goal of my project: backend app
    for the courses of the training center, the courses chosen by the students, the students of the courses
     `,
        url: "https://github.com/abduhamidweb/Imtihon",
      },





      {
        id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzQ=",
        name: "Countries ",
        createdAt: " 2022.09.06",
        description: `
    The goal of my project: frontend react app
    for country flags and their rates
     `,
        url: "https://allcountrydev.netlify.app/",
      },




      {
        id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzQ=https://allcountrydev.netlify.app/",
        name: "inwood",
        createdAt: " 2022.10.08",
        description: `
    The goal of my project: you can find an apartment
    for yourself.
     `,
        url: "https://enchanting-cajeta-5bc006.netlify.app/",
      },
      {
        id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzQ=https://allcountrydev.netlify.app/",
        name: "Learn English",
        createdAt: " 2023.04.01",
        description: `
    The goal of my project: we learn English through games.
     `,
        url: "https://spiffy-platypus-cfd35d.netlify.app/register.html",
      },





      {
        id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzQ=https://allcountrydev.netlify.app/",
        name: "Prayer Times",
        createdAt: " 2022.09.22",
        description: `
    The goal of my project: you can know the prayer times.
     `,
        url: "https://nomozvaqtlaridev.netlify.app/",
      },



      {
        id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzQ=https://allcountrydev.netlify.app/",
        name: "Spaid",
        createdAt: " 2023.02.03",
        description: `
    The goal of my project: an easy way to get food delivered.
     `,
        url: "https://spectacular-genie-b6fd93.netlify.app/",
      },
      {
        id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzQ=https://allcountrydev.netlify.app/",
        name: "Youtube",
        createdAt: " 2022.12.21",
        description: `
    The goal of my project: A web application developed in cooperation with YouTube
     `,
        url: "https://youtubeclonedev.netlify.app/",
      },






      {
        id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzQ=https://allcountrydev.netlify.app/",
        name: "Landing page",
        createdAt: " 2023.03.11",
        description: `
    The goal of my project: Tips
    for protecting your web server
     `,
        url: "https://resonant-cannoli-bb6330.netlify.app/",
      },



      {
        id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzQ=https://allcountrydev.netlify.app/",
        name: "super memory",
        createdAt: " 2023.03.23",
        description: `
    The goal of my project: you can use this site to memorize numbers.
     `,
        url: "https://fleshcards.netlify.app/",
      },


      {
        id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzQ=https://github.com/abduhamidweb/Responsive-Sidebar",
        name: "my little protfolio project",
        createdAt: " 2023.03.23",
        description: `
    The goal of my project: a web application that provides information about your projects and yourself.
     `,
        url: "https://grand-yeot-1b6cb2.netlify.app/",
      },


      {
        id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzQ=",
        name: "Responsive-Sidebar",
        createdAt: " 2022.11.02",
        description: `
    The goal of my project: Responsive Sidebar.
     `,
        url: "https://gleeful-chaja-c26a7a.netlify.app/home",
      },


      {
        id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzQ=",
        name: "Pokemons",
        createdAt: " 2022.10.12",
        description: `
    The goal of my project: show your favorite pokemon
    for kids.
     `,
        url: "https://pokemonsdev.netlify.app/",
      },
    ],
  },
};

/*******************          Contact Page          ****************/

// const contactPageData = {
//   contactSection: {
//     title: "Contact Me",
//     profile_image_path: "myPhoto.png",
//     description: "I am available in email and messenger. You can message me (except hi/hello), I will reply within 24 hours. I can help you with Python, shell, web application, android app development.",
//   },
//   blogSection: {
//     title: "Blogs",
//     subtitle: "I have written some stories and poems in my native language.",
//     link: "https://Abduhamid.github.io/kasweb",
//     avatar_image_path: "blogs_image.svg",
//   },
//   addressSection: {
//     title: "Address",
//     subtitle: "Kalkini, Madaripur, Dhaka, Bangladesh",
//     avatar_image_path: "address_image.svg",
//     location_map_link: "https://www.google.com/maps/@23.0840366,90.1250967,22z?gl=bd",
//   },
//   phoneSection: {
//     title: "Phone Number",
//     subtitle: "01920687832",
//   },
// };
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "myPhoto.png",
    description: "I am available on almost every social media. You can message me, I will reply within 24 hours. I can help you with NodeJs JavaScript,ExpressJs and etc.",
  },
  blogSection: {
    title: "Blogs",
    subtitle: "For individual fundamental empowerment, I like to write powerful lessons that create impact on each of the reader individually to change the core of their character.",
    link: "https://t.me/Code_Crafters_Team",
    avatar_image_path: "my_img.jpg",
  },
  addressSection: {
    title: "Address",
    subtitle: "Tashkent, Uzbekistan",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://goo.gl/maps/7TyAN59F2FYZuj157",
  },
  phoneSection: {
    title: "+998 99 786 70 75",
    subtitle: "You can call me 24/7.",
  },
};
// Send a message in emailjs account
const contactMessage = {
  display: true, // Set it false if you don't have emailjs account or you don't want message, defaults to true
  emailjsUserID: "nAmE3pQlkbzCk7Up9",
  templateID: "outlook1",
  serviceID: "service_ya9vkyn",
};

export {
  pageEnabled,
  routerValue,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  techStack,
  competitiveSites,
  degrees,
  certifications,
  experience,
  hobbies,
  podcastSection,
  bigProjects,
  talkSection,
  openSource,
  projects,
  publications,
  blogSection,
  contactPageData,
  contactMessage,
  twitterUsername,
  splashScreen,
};